import type { IncidentListItem } from '@prerender/diagnostics-api';

type TriggerOfIncident = Pick<IncidentListItem, 'triggerValue' | 'triggerDomainCount'>;

export const triggerValueLabel = ({ triggerValue, triggerDomainCount }: TriggerOfIncident): string => {
  const percent = `${Math.round(triggerValue)}%`;

  return triggerDomainCount > 1 ? `up to ${percent}` : percent;
};
